import script from "./Login.vue?vue&type=script&lang=ts&setup=true"
export * from "./Login.vue?vue&type=script&lang=ts&setup=true"

import "@/assets/styles/scss/login.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__